import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-center" }

import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import SfxContextMenu from "src/components/navigation/SfxContextMenu.vue"
import { useConfigurationStore } from "src/stores/configurationStore"
import { useNotificationsStore } from "src/stores/notificationsStore"
import { ContextMenuItem } from "src/util/classes/contextMenuItem"
import { ContextAction } from "src/util/enums/entityType"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { showNotImplementedNotification } from "src/util/functions/notifications"
import { computed, onUnmounted, PropType, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits

const animationInterval = 1000 // ms
const vibrationTimer = 1000 // ms

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxContextBarManager',
  props: {
  quickActions: Array as PropType<Array<ContextAction>>,

  disableQuickActions: Array as PropType<Array<ContextAction>>,

  contextMenuContent: {
    type: Array as PropType<Array<ContextAction>>,
    required: true,
  },

  disableContextMenuContent: Array as PropType<Array<ContextAction>>,

  hideQuickActions: Boolean,

  hideContextMenu: Boolean,

  disableContextMenu: Boolean,

  hideSeparator: Boolean,

  hideNotifications: Boolean,

  disableNotifications: Boolean,

  hideTodoIcon: Boolean,

  disableTodoIcon: Boolean,
},
  emits: ["contextSelect"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const { t } = useI18n()
const notificationsStore = useNotificationsStore()
const notificationCount = computed(() => notificationsStore.count)
const configurationStore = useConfigurationStore()
const enableAnimation = computed(() => configurationStore.animateNotification)

const quickActionItems = computed(() => {
  if (props.quickActions && props.quickActions.length > 0) {
    return ContextMenuItem.getContextMenuItems(props.quickActions, props.disableQuickActions, true)
  }
  return null
})

const contextMenuItems = computed(() =>
  ContextMenuItem.getContextMenuItems(props.contextMenuContent, props.disableContextMenuContent)
)

const animatedIconClass = computed(() => {
  return { invisible: !animationState.value }
})

const animationState = ref<boolean>(false)
let animationObject: ReturnType<typeof setInterval> | undefined

const vibrationState = ref<boolean>(false)
const vibrateClass = computed(() => {
  return { "vibrate-bell": vibrationState.value && !enableAnimation.value }
})

const bellIconOn = Icons.NOTIFICATIONS_NEW + " fa-stack-1x"
const bellIcon = Icons.NOTIFICATIONS + " fa-stack-1x"

const toDoLabel = t("sfxNavigation.to_do")
const contextMenuLabel = t("sfxNavigation.more")
const notificationsLabel = t("sfxNavigation.notifications")

//endregion

//region Lifecycle

onUnmounted(stopNotificationAnimation)

//endregion

//region Functions

function handleContextSelection(contextMenuItem: ContextMenuItem) {
  emit("contextSelect", contextMenuItem)
}

function handleTodoClick() {
  showNotImplementedNotification()
}

function stopNotificationAnimation() {
  clearInterval(animationObject)
  animationObject = undefined
  animationState.value = false
}

//endregion

//region Setup Code

watch(
  () => notificationCount.value && enableAnimation.value,
  () => {
    // Clear any lingering intervals
    if (animationObject) {
      stopNotificationAnimation()
    }

    // Start only if there are notifications
    if (notificationCount.value > 0 && enableAnimation.value) {
      animationObject = setInterval(
        () => (animationState.value = !animationState.value),
        animationInterval
      )
    }
  },
  { immediate: true }
)

watch(
  () => notificationCount.value,
  (newCount, oldCount) => {
    // Only vibrate if the number of notifications is increased
    if (newCount > oldCount) {
      vibrationState.value = true

      // Remove vibration class after X amount of seconds
      setTimeout(() => {
        vibrationState.value = false
      }, vibrationTimer)
    }
  }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_badge = _resolveComponent("q-badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!props.hideQuickActions)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(quickActionItems.value, (quickAction) => {
          return (_openBlock(), _createBlock(SfxBtnIcon, {
            key: quickAction,
            icon: quickAction.icon,
            disable: quickAction.disable,
            title: quickAction.content,
            onClick: ($event: any) => (handleContextSelection(quickAction)),
            class: "sfx-quick-action-icon"
          }, null, 8, ["icon", "disable", "title", "onClick"]))
        }), 128))
      : _createCommentVNode("", true),
    (!props.hideContextMenu)
      ? (_openBlock(), _createBlock(SfxBtnIcon, {
          key: 1,
          icon: _unref(Icons).CONTEXT_MENU,
          disable: props.disableContextMenu,
          title: _unref(contextMenuLabel)
        }, {
          default: _withCtx(() => [
            _createVNode(SfxContextMenu, {
              "context-menu-items": contextMenuItems.value,
              onContextSelect: handleContextSelection,
              class: "sfx-context-menu__manager"
            }, null, 8, ["context-menu-items"])
          ]),
          _: 1
        }, 8, ["icon", "disable", "title"]))
      : _createCommentVNode("", true),
    (!props.hideSeparator)
      ? (_openBlock(), _createBlock(_component_q_separator, {
          key: 2,
          vertical: "",
          inset: ""
        }))
      : _createCommentVNode("", true),
    (!props.hideNotifications)
      ? (_openBlock(), _createBlock(SfxBtn, {
          key: 3,
          flat: "",
          dense: "",
          round: "",
          size: "lg",
          disable: __props.disableNotifications,
          title: _unref(notificationsLabel),
          onClick: _unref(showNotImplementedNotification),
          class: "q-mr-xs"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              (!props.disableNotifications)
                ? (_openBlock(), _createBlock(_component_q_icon, {
                    key: 0,
                    name: bellIconOn,
                    class: _normalizeClass(["sfx-btn--animate", animatedIconClass.value])
                  }, null, 8, ["class"]))
                : _createCommentVNode("", true),
              _createVNode(_component_q_icon, {
                name: bellIcon,
                class: _normalizeClass(vibrateClass.value)
              }, {
                default: _withCtx(() => [
                  (!props.disableNotifications && notificationCount.value > 0)
                    ? (_openBlock(), _createBlock(_component_q_badge, {
                        key: 0,
                        color: "red",
                        floating: "",
                        rounded: "",
                        align: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(notificationCount.value), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["class"])
            ])
          ]),
          _: 1
        }, 8, ["disable", "title", "onClick"]))
      : _createCommentVNode("", true),
    (!props.hideTodoIcon)
      ? (_openBlock(), _createBlock(SfxBtnIcon, {
          key: 4,
          icon: _unref(Icons).LIST_DISPLAY,
          disable: props.disableTodoIcon,
          title: _unref(toDoLabel),
          onClick: handleTodoClick
        }, null, 8, ["icon", "disable", "title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})